<template>
  <div class="draw-lots">
    <div class="header-banner">
      <img :src="homeConfig.homepageHeaderImage" alt="">
      <!-- <div class="draw-lot-title" :class="['draw-lot-title-'+stage]"></div> -->
       <div class="draw-lot-title" :style="{backgroundImage: `url(${drawLotsTitleImage})`}"></div>
    </div>
    <div class="draw-lots-time">
      {{drawLotsTime}}
    </div>
    <div class="team-name">{{teamName}}</div>
    <p class="draw-lots-desc">每个赛程仅有一次抽签机会，过期未抽签将自动随机分配</p>
    <div class="card-container" :class="{ 'jinjichang-container': stage === 3 }">
      <div 
        v-for="(card, index) in displayCards" 
        :key="card.id" 
        class="card" 
        @click="handleCardClick(index)" 
        :class="{
          back: !card.revealed && !showInitialText,
          revealed: card.revealed,
          clickable: card.clickable,
          shuffling: isShuffling,
          jinjichang: stage == 3
        }"
        :style="{
          left: `${card.x}%`,
          top: `${card.y}px`,
          transitionDelay: `${card.transitionDelay}s`,
          ...( !card.revealed && !showInitialText ? getCardBackStyle() : {} )
        }"
      >
        <div class="card-content">
          <div class="card-text" :style="{color: drawConfig.drawCardFrontTextColor ? `${drawConfig.drawCardFrontTextColor}` : ''}" v-html="formatCardText(card.revealed ? drawResult : (showInitialText ? card.text : ''))">
          </div>
        </div>
      </div>
    </div>
    <div v-if="gameStarted == 1" class="draw-mask"></div>
    <div v-if="gameStarted == 1" class="draw-btn" :disabled="isShuffling || gameStarted" @click="shuffleCards">
      <img :src="drawConfig.drawCardButtonImage" alt="">
    </div>
    <van-dialog
      v-model="showDrawResult"
      title="完成抽签"
      @confirm="toDrawResult"
      confirmButtonColor="#58ABF6"
      confirmButtonText="返回"
      cancelButtonText="查看分区情况"
    >
      <div class="draw-result-content">
        <p class="draw-team-name">{{teamName}}</p>
        <p v-if="stage == 1">已抽取全国大赛小组赛的分组</p>
        <p v-if="stage == 2">已抽取精英争霸赛的战区</p>
        <p v-if="stage == 3">已抽取竞技场争霸赛的战区</p>
        <p class="draw-result">{{ drawResult }}</p>
        <div class="draw-result-info">
          <span>抽签人：{{ createByName }}</span>
          <span>抽签时间：{{ drawTime }}</span>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  getAgentAllZone,
  getAgentTeamZone
} from "../../api/winterGame";
import { Toast } from "vant";
export default {
  data() {
    return {
      showInitialText: true,
      isShuffling: false,
      gameStarted: -1,
      showDrawResult: false,
      drawResult: '',
      cards: [],
      displayCards: [],
      positions: [],
      drawEndTime: '',
      teamName: '',
      padTeamId: '',
      seasonId: '',
      scheduleId: '',
      campusId: '',
      currentUserId: '',
      createByName: '',
      drawTime: '',
      stage:'',
      drawConfig: {},
      homeConfig: {},
      drawLotsTitleImage: '',
      drawLotsTime: '', // 截止时间
    }
  },
  async created() {
    const homeConfig = JSON.parse(sessionStorage.getItem('homeConfig'));
    this.homeConfig = homeConfig;
    this.campusId = this.$route.query.currentCampusId;
    this.padTeamId = this.$route.query.padTeamId;
    this.seasonId = this.$route.query.seasonId;
    this.scheduleId = this.$route.query.scheduleId;
    if (this.scheduleId.indexOf('tuandui.xiaozu') !== -1 ) { // 全国大赛小组赛
      this.stage = 1;
    } else if (this.scheduleId.indexOf('tuandui.jingying') !== -1) { // 精英争霸赛
      this.stage = 2;
    } else if (this.scheduleId.indexOf('jingjichang') !== -1) { // 竞技场争霸赛
      this.stage = 3;
    }
    this.currentUserId = this.$route.query.currentUserId;
    const cardData = await this.getAgentAllZone();
    const { drawGroupList, drawEndTime, teamName, isDrawed, isOverDrawed, agentGroupTeamBy, drawConfig } = cardData;
    this.drawEndTime = drawEndTime;
    this.teamName = teamName;
    this.drawConfig = drawConfig;
    if (this.stage == 1) {
      this.drawLotsTitleImage = this.drawConfig.nationalTournamentGroupDrawTopImage;
      this.drawLotsTime = this.formatDrawLotsTime(this.drawConfig.nationalTournamentGroupDrawDate);
    } else if (this.stage == 2) {
      this.drawLotsTitleImage = this.drawConfig.eliteBattleDrawTopImage;
      this.drawLotsTime = this.formatDrawLotsTime(this.drawConfig.eliteBattleDrawDate);
    } else if (this.stage == 3) {
      this.drawLotsTitleImage = this.drawConfig.eliteBattleDrawTopImage;
      this.drawLotsTime = this.formatDrawLotsTime(this.drawConfig.eliteBattleDrawDate);
    }

    this.gameStarted = drawGroupList.length > 0 ? 1 : 0;
    if (isOverDrawed && agentGroupTeamBy) { // 已经抽签
      this.gameStarted = 0
      this.drawResult = agentGroupTeamBy.drawGroupName;
      this.createByName = agentGroupTeamBy.createByName;
      this.drawTime = agentGroupTeamBy.drawTime;
      setTimeout(() => {
        this.showDrawResult = true;
      }, 500)
    }
    let i = 0;
    this.cards = drawGroupList.map(item => {
      return {
        id: i++,
        text: item,
        revealed: false,
        clickable: false
    }});
    console.log(this.cards);
    this.initCards();
  },
  methods: {
    // 格式化抽签截止时间为 "xx月xx日 HH:MM截止"
    formatDrawLotsTime(dateTime) {
      if (!dateTime) {
        return "";
      }
      try {
        // 检查是否是 yyyy-MM-dd 格式（没有时间部分）
        const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateTime);
        
        let time;
        let hours = '23';
        let minutes = '00';
        
        if (isDateOnly) {
          // 如果是 yyyy-MM-dd 格式，直接解析日期，使用固定的 23:00
          time = new Date(dateTime);
        } else {
          // 如果有时间部分，解析完整日期时间
          time = new Date(dateTime);
          hours = time.getHours().toString().padStart(2, '0');
          minutes = time.getMinutes().toString().padStart(2, '0');
        }
        
        const month = time.getMonth() + 1;
        const day = time.getDate();
        return `${month}月${day}日 ${hours}:${minutes}截止`;
      } catch (error) {
        console.error('格式化日期失败:', error);
        return dateTime; // 如果格式化失败，返回原始值
      }
    },
    async getAgentAllZone() {
     return new Promise((resolve, reject) => {
      let params = {
        param: {
          campusId: this.campusId,
          padTeamId: this.padTeamId,
          seasonId: this.seasonId,
          scheduleId: this.scheduleId,
          // seasonId: 's.25.xiaji.1.test',
          // scheduleId: 'skd.25.xiaji.1.tuandui.jingying.test',
        },
      };
      getAgentAllZone(params).then(res => {
        if (res.code == 0) {
          resolve(res.data);
        }
      });
     })
    },
    getCardBackStyle() {
      if (this.drawConfig.drawCardBackImage) {
        return {
          background: `url(${this.drawConfig.drawCardBackImage}) no-repeat center center !important`,
          backgroundSize: 'cover !important',
          width: '76px !important',
          height: '104px !important'
        };
      } else {
        return {
          background: `url(${require('../../assets/images/winterGame/drawLots/cardBack.png')}) no-repeat center center !important`,
          backgroundSize: 'cover !important',
          width: '76px !important',
          height: '104px !important'
        };
      }
    },
    initCards() {
      // 根据stage决定布局：stage=3时使用3列，其他使用4列
      const columns = this.stage === 3 ? 3 : 4;
      const rows = Math.ceil(this.cards.length / columns);
      
      // 根据stage决定卡片高度和间距
      const cardHeight = this.stage === 3 ? 176 : 116;
      const cardSpacing = 16;
      
      // 初始化位置数组
      this.positions = [];
      
      for (let i = 0; i < this.cards.length; i++) {
        const row = Math.floor(i / columns);
        const col = i % columns;
        
        // 计算每列的中心位置
        let centerPositions;
        if (columns === 3) {
          // 3列布局：16.67%, 50%, 83.33%
          centerPositions = [16.67, 50, 83.33];
        } else {
          // 4列布局：12.5%, 37.5%, 62.5%, 87.5%
          centerPositions = [12.5, 37.5, 62.5, 87.5];
        }
        
        this.positions.push({
          x: centerPositions[col], // 使用中心位置的百分比
          y: row * (cardHeight + cardSpacing) // 每行的起始位置：行数 * (卡片高度 + 间距)
        });
      }
      
      // 初始化显示卡片
      this.displayCards = this.cards.map((card, index) => ({
        ...card,
        x: this.positions[index].x,
        y: this.positions[index].y,
        transitionDelay: index * 0.05
      }));
    },
    
    sleep(ms) {
      return new Promise(res => setTimeout(res, ms));
    },
    
    // 随机打乱一次位置
    shuffleOnce() {
      const indices = [...Array(this.cards.length).keys()];
      for (let i = indices.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [indices[i], indices[j]] = [indices[j], indices[i]];
      }
      
      this.displayCards = this.displayCards.map((card, i) => ({
        ...card,
        x: this.positions[indices[i]].x,
        y: this.positions[indices[i]].y
      }));
    },
    
    async shuffleCards() {
      this.isShuffling = true;
      this.gameStarted = -1; // 标记游戏已开始，按钮永久禁用
      
      // 1. 背面化（移除上轮可能残留的 clickable/revealed）
      this.showInitialText = false;
      this.displayCards = this.displayCards.map(card => ({
        ...card,
        revealed: false,
        clickable: false
      }));
      await this.sleep(200);
      
      // 2. 连续多轮洗牌，每轮 shuffleOnce + 等待
      for (let i = 0; i < 3; i++) {
        this.shuffleOnce();
        await this.sleep(250);
      }
      
      // 3. 等待最后一轮CSS动画完成（CSS transition: 0.3s）
      await this.sleep(350); // 额外等待350ms确保CSS动画完成
      
      // 4. 给"洗牌后背面"卡片添加 clickable
      this.displayCards = this.displayCards.map(card => ({
        ...card,
        clickable: true
      }));
      
      this.isShuffling = false;
    },
    
    revealCard(index) {
      // 这个方法现在由handleCardClick代替
    },
    handleShufflingClick() {
      // 可以添加一些用户反馈，比如震动或提示
    },
    async handleCardClick(index) {
      
      // 多重检查：洗牌过程中不允许点击卡片
      if (this.isShuffling) {
        return;
      }
      
      // 确保游戏已开始且不在洗牌状态
      if (!this.gameStarted) {
        return;
      }
      
      const card = this.displayCards[index];
      
      if (!card.revealed && card.clickable) {
        // 揭示选中的卡片，同时将所有卡片设为不可点击
        this.displayCards = this.displayCards.map((card, i) => ({
          ...card,
          revealed: i === index ? true : card.revealed,
          clickable: false // 所有卡片都变为不可点击
        }));
        const params = {
          param: {
            campusId: this.campusId,
            padTeamId: this.padTeamId,
            seasonId: this.seasonId,
            scheduleId: this.scheduleId,
            userId: this.currentUserId
          },
        };
        const res = await getAgentTeamZone(params);
        if (res.code == 0) {
          this.drawResult = res.data.drawGroupName;
          this.createByName = res.data.createByName;
          this.drawTime = res.data.drawTime;
          setTimeout(() => {
            this.showDrawResult = true;
          }, 1000)
        } else {
          Toast(res.message);
        }
      }
    },
    toDrawResult() {
      this.$router.back();
    },
    viewZone() {
      const rankingJump = sessionStorage.getItem('rankingJump');
      if (rankingJump) {
        window.location.href = rankingJump;
      }
    },
    // 处理文案换行显示
    formatCardText(text) {
      if (!text) return '';
      
      console.log('处理文案:', text); // 调试信息
      
      // 匹配模式：金牛座战区、泰山地区、青龙1组等
      const patterns = [
        /^(.+?)(战区|地区)$/, // 匹配 金牛座战区、泰山地区
        /^(.+?)(\d+组)$/, // 匹配 青龙1组、白虎2组等
        /^(.+?)([A-Z]+组)$/, // 匹配 青龙A组、白虎B组等
        /^(.+?)(组)$/ // 匹配 青龙组、白虎组等
      ];
      
      for (const pattern of patterns) {
        const match = text.match(pattern);
        if (match) {
          const [, prefix, suffix] = match;
          const result = `${prefix}\n${suffix}`;
          console.log('匹配成功:', text, '->', result); // 调试信息
          return result;
        }
      }
      
      // 如果没有匹配到模式，返回原文本
      console.log('未匹配，返回原文本:', text); // 调试信息
      return text;
    }
  },
}
</script>

<style lang="less" scoped>
.draw-lots {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #0289CB 0%, #11A3C2 100%);
  overflow-y: auto;
  .header-banner {
    position: relative;
    width: 100%;
    height: 324px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .draw-lot-title {
      position: absolute;
      top: 90%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 510px;
      height: 62px;
      background-size: 100% 100%;
      &.draw-lot-title-1 {
        background: url('../../assets/images/winterGame/drawLots/drawLotTitle3.png') no-repeat center center;
        background-size: 100% 100%;
      }
      &.draw-lot-title-2 {
        background: url('../../assets/images/winterGame/drawLots/drawLotTitle2.png') no-repeat center center;
        background-size: 100% 100%;
      }
      &.draw-lot-title-3 {
        background: url('../../assets/images/winterGame/drawLots/drawLotTitle1.png') no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
  
  .draw-lots-time {
    width: 352px;
    height: 48px;
    margin: 20px auto;
    background: #007DBA;
    border-radius: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #FFFFFF;
    line-height: 48px;
    text-align: center;
    font-style: normal;
  }

  .team-name {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    font-style: normal;
  }
  
  button {
    display: block;
    width: 200px;
    height: 60px;
    margin: 20px auto;
    background: linear-gradient(45deg, #FF9A00, #FF5E00);
    color: white;
    border: none;
    border-radius: 30px;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s, box-shadow 0.3s;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
  }
  
  .card-container {
    position: relative;
    width: calc(100% - 48px); // 自适应宽度，左右各留20px边距
    margin: 32px auto 0; // 改为px单位
    min-height: 1020px; // 设置一个合理的最小高度
    padding-bottom: 16px; // 减少底部间距
    
    &.jinjichang-container {
      min-height: 1200px; // 竞技场容器需要更大的高度来容纳更高的卡片
    }
    .card {
      width: calc(25% - 20px);
      height: 216px;
      border-radius: 12px;
      position: absolute;
      background: url('../../assets/images/winterGame/drawLots/cardBg.png') no-repeat center center;
      background-size: 100% 100%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 16px;
      color: #222;
      cursor: pointer;
      transition: left 0.3s ease-in-out, top 0.3s ease-in-out, background 0.5s ease, color 0.5s ease;
      transform: translateX(-50%);
      will-change: transform;
      
      /* 可点击时悬停效果 */
      &.clickable:hover {
        transform: translateX(-50%) scale(1.02);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      }
      
      /* 洗牌状态 */
      &.shuffling {
        cursor: not-allowed !important;
        pointer-events: none !important;
      }
      .card-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .card-text {
          width: 100px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 32px;
          color: #007DBA;
          line-height: 40px;
          text-align: center;
          font-style: normal;
          white-space: pre-line;
          &.small-text {
            width: 80px;
          }
        }
        .card-desc {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 28px;
          color: #007DBA;
          line-height: 40px;
          text-align: center;
          font-style: normal;
        }
      }
      /* 背面状态 */
      &.back {
        background: url('../../assets/images/winterGame/drawLots/cardBack.png') no-repeat center center;
        background-size: 100% 100%;
        color: transparent;
      }
      
      /* 揭示签文状态 */
      &.revealed {
        // background: #fef08a;
        // color: #111;
      }
      &.jinjichang {
        width: calc(33.33% - 20px);
        height: 276px;
        margin: 0 10px;
      }
    }
  }
  
  @keyframes shake {
    0% { transform: translateX(0); }
    20% { transform: translateX(-3px); }
    40% { transform: translateX(3px); }
    60% { transform: translateX(-3px); }
    80% { transform: translateX(3px); }
    100% { transform: translateX(0); }
  }
  .draw-lots-desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 34px;
    text-align: center;
    font-style: normal;
    margin: 10px auto 5px;
  }
  .draw-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.25);
    z-index: 10;
  }
  .draw-btn {
    position: fixed;
    left: 50%;
    top: 60%;
    transform: translate(-50%, -50%);
    width: 232px;
    height: 232px;
    z-index: 11;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .draw-result-content {
    padding: 0 32px;
    .draw-team-name {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #323232;
      line-height: 44px;
      text-align: center;
      font-style: normal;
    }
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #323232;
      line-height: 44px;
      text-align: center;
      font-style: normal;
      margin: 0;
      padding: 0;
    }
    .draw-result {
      margin: 16px 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 40px;
      color: #58ABF6;
      line-height: 56px;
      text-align: center;
      font-style: normal;
    }
    .draw-result-info {
      padding-bottom: 32px;
      display: flex;
      justify-content: space-around;
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #323232;
        line-height: 44px;
        text-align: center;
        font-style: normal;
      }
    }
  }
}
</style>

<style lang="less">
#app {
  height: 100vh;
}
</style>